import { z } from 'zod';

/**
 * Período de análise do BI. Default da UI = D30. `from`/`to` em
 * `YYYY-MM-DD` no fuso `America/Sao_Paulo` (BRT) — ver Sprint 4 §"Period
 * presets". Compartilhado entre `apps/admin` (PeriodPicker) e callables
 * que recebem filtros.
 */

const DateOnlyRegex = /^\d{4}-\d{2}-\d{2}$/;

export const PeriodPresetSchema = z.enum([
  'TODAY',
  'D7',
  'D30',
  'D90',
  'M12',
  'MTD',
  'YTD',
  'CUSTOM',
]);
export type PeriodPreset = z.infer<typeof PeriodPresetSchema>;

export const PeriodSchema = z.object({
  preset: PeriodPresetSchema,
  from: z.string().regex(DateOnlyRegex),
  to: z.string().regex(DateOnlyRegex),
});
export type Period = z.infer<typeof PeriodSchema>;
